import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
// import Select from "react-select";
import Model from "../Model";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  gCouncilList,
  gDistrictsList,
  gRegionsList,
  gTypeOfRegistration,
  gTypeOfAssociations,
} from "../../Config";

const AddSubAdminModel = ({
  SingleEntryLoading,
  postAddUser,
  setOpenUploadModel,
  selectedRegionDetails,
  setselectedRegionDetails,
}) => {
  const { t, i18n } = useTranslation();

  const InitialValues = {
    region: "",
    regionLabel: "",
    district: "",
    districtLabel: "",
    // region: selectedRegionDetails || "",
  };
  console.log(
    selectedRegionDetails?.map((item) => ({
      ...item,
      label: item.name,
      value: item.name,
    }))
  );

  const SubmitHandler = (values) => {
    console.log(values);
    if (!values.region) {
      toast.error("Please select a region first.");
      return;
    }

    if (!values.district) {
      toast.error("Please enter a district.");
      return;
    }
    postAddUser(values);
  };

  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setOpenUploadModel}>
      <Title>Add District</Title>

      {SingleEntryLoading && <Loading />}

      {!SingleEntryLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              {/* <CombineInputGroup> */}
              <InputGroup>
                <Label htmlFor="region">{t("c_region")}</Label>
                <FieldWrapper $select={true}>
                  <Field required name="region" id="region" autoComplete="off">
                    {(props) => (
                      <Select className="w-full h-full" {...props.field}>
                        <MenuItem value="N/A" disabled>
                          Select Region
                        </MenuItem>
                        {selectedRegionDetails?.map((item) => (
                          <MenuItem key={item?.id} value={item?.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </Field>
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="district">District Name</Label>
                <FieldWrapper>
                  <Field
                    name="district"
                    id="district"
                    autoComplete="off"
                    required
                  />
                </FieldWrapper>
              </InputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Add</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center mt-8`;

export default AddSubAdminModel;
